<template>
    <div class='content'>
        <div class="con-1">
            <div :class="$i18n.locale + '_con-2'">{{ $t('content151') }}</div>
            <div class='con-3'>
                {{ $t('content152') }}
            </div>
            <!-- <div class="btn-box">
                <div class="btn-blue">预约演示</div>
                <div class="btn-we">参观一下</div>
            </div> -->
            <img :src="$i18n.locale == 'zh' ? require('@/assets/gongyingshang_banner@2x.png'):require('@/assets/en_gongyingshang_banner@2x.png')" class="con-img" alt="">
        </div>

        <div class="con-flex">
            <div class="con-title">
                <div class="con-4">{{ $t('content153') }}</div>
                <div class="con-5">
                    {{ $t('content154') }}
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 25@2x.png" class="con-img1" alt="">
                    <div class="con-text1">{{ $t('content155') }}</div>
                </div>
                <div class="con-7">
                    <img src="@/assets/Slice 25@2x.png" class="con-img1" alt="">
                    <div class="con-text1">{{ $t('content156') }}</div>
                </div>
                <div class="con-7">
                    <img src="@/assets/Slice 25@2x.png" class="con-img1" alt="">
                    <div class="con-text1">{{ $t('content157') }}</div>
                </div>
            </div>
            <div class="con-8">
                <img :src="$i18n.locale == 'zh' ? require('@/assets/yijian_img@2x.png'):require('@/assets/en_yijian_img@2x.png')" class="con-8-img" alt="">
            </div>
        </div>

        <div class="con-flex">
            <div class="con-9" :class="$i18n.locale + '_con-13'">
                <img :src="$i18n.locale == 'zh' ? require('@/assets/0fengxian_img@2x.png'):require('@/assets/en_0fengxian_img@2x.png')" class="imgs" alt="">
            </div>
            <div :class="$i18n.locale + '_con-10'">
                <div class="con-11">{{ $t('content158') }}</div>
                <div class="con-12">
                    {{ $t('content159') }}
                </div>
                <div class="con-13">
                    <img src="@/assets/Slice 25@2x.png" class="con-img1" alt="">
                    <div class="con-text1">
                        {{ $t('content160') }}
                    </div>
                </div>

                <div class="con-14">
                    <img src="@/assets/Slice 25@2x.png" class="con-img1" alt="">
                    <div class="con-text1">{{ $t('content161') }}</div>
                </div>
                <div class="con-14">
                    <img src="@/assets/Slice 25@2x.png" class="con-img1" alt="">
                    <div class="con-text1">{{ $t('content162') }}</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'index_3',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>
.con-1 {
    position: relative;
}

.zh_con-2 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 237px;
    left: 360px;
}

.en_con-2 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 180px;
    left: 280px;
    width: 700px;
    text-align: center;
}

.con-3 {
    width: 484px;
    font-size: 22px;
    color: #666666;
    position: absolute;
    left: 360px;
    top: 306px;
    line-height: 32px;
}

.con-img {
    width: 100%;
    height: 750px;
}

.con-flex {
    display: flex;
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 450px;
    left: 360px;
}

.con-4 {
    font-size: 36px;
    color: #333333;
    margin-bottom: 34px;
}

.con-5 {
    font-size: 22px;
    color: #666666;
    margin-bottom: 32px;
    line-height: 32px;
}

.con-6 {
    display: flex;
    align-items: center;
}

.con-title {
    width: 473px;
    margin-left: 361px;
    margin-top: 206px;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    color: #fff;
  cursor: pointer;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
}

.btn-we {
    width: 132px;
  cursor: pointer;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #4873FF;
    margin-left: 12px;

}

.imgs {
    width: 751px;
    height: 628px;
    margin-top: -20px;
}

.con-img1 {
    width: 18px;
    height: 18px;
}

.con-text1 {
    font-size: 20px;
    color: #333333;
    margin-left: 12px;
}

.con-7 {
    display: flex;
    align-items: center;
    margin-top: 11px;
}

.con-8 {
    width: 732px;
    height: 708px;
    margin-top: 15px;
}

.con-8-img {
    width: 100%;
    height: 100%;
}

.con-9 {
    margin-left: 294px;
}

.en_con-10 {
    margin-left: 50px;
    width:700px;
    margin-top: 108px;
}
.zh_con-10 {
    margin-left: 87px;
    margin-top: 108px;
}

.con-11 {
    font-size: 36px;
    color: #333333;
    margin-bottom: 27px;
    width: 544px;
}

.con-12 {
    font-size: 22px;
    color: #666666;
    margin-bottom: 32px;
    width: 555px;
    line-height: 32px;
}

.con-13 {

    display: flex;
    align-items: center;
}

.con-14 {
    display: flex;
    align-items: center;
    margin-top: 20px;
}
</style>